var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectSeat',{ref:"select-seat",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('van-nav-bar',{attrs:{"title":"选择座位","left-arrow":""},on:{"click-left":_vm.goBackTo}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }